import * as dateFns from 'date-fns';

import { de } from 'date-fns/locale';
import { getHolidays, isHoliday, getHolidayByDate } from 'feiertagejs';

export function startOfWeek(date) {
  return dateFns.startOfWeek(toDate(date), { locale: de, weekStartsOn: 1 });
}
export function endOfWeek(date) {
  return dateFns.endOfWeek(toDate(date), { locale: de, weekStartsOn: 1 });
}

export function startOfISOWeek(date) {
  return dateFns.startOfISOWeek(toDate(date));
}

export function endOfISOWeek(date) {
  return dateFns.endOfISOWeek(toDate(date));
}

export function startOfDay(date) {
  return dateFns.startOfDay(toDate(date));
}

export function endOfDay(date) {
  return dateFns.endOfDay(toDate(date));
}

export function startOfMonth(date) {
  return dateFns.startOfMonth(toDate(date));
}

export function endOfMonth(date) {
  return dateFns.endOfMonth(toDate(date));
}

export function startOfYear(date) {
  return dateFns.startOfYear(toDate(date));
}

export function endOfYear(date) {
  return dateFns.endOfYear(toDate(date));
}

export function formatDate(date, format = 'dd.MM.yyyy') {
  return dateFns.format(toDate(date), format, { locale: de, weekStartsOn: 1 });
}

export function addDays(date, number) {
  return dateFns.addDays(toDate(date), number);
}

export function addWeeks(date, number) {
  return dateFns.addWeeks(toDate(date), number);
}

export function addYears(date, number) {
  return dateFns.addYears(toDate(date), number);
}

export function addMonths(date, number) {
  return dateFns.addMonths(toDate(date), number);
}
export function addMinutes(date, number) {
  return dateFns.addMinutes(toDate(date), number);
}

export function addSeconds(date, number) {
  return dateFns.addSeconds(toDate(date), number);
}

export function subDays(date, number) {
  return dateFns.subDays(toDate(date), number);
}

export function subWeeks(date, number) {
  return dateFns.subWeeks(toDate(date), number);
}

export function subYears(date, number) {
  return dateFns.subYears(toDate(date), number);
}

export function subMonths(date, number) {
  return dateFns.subMonths(toDate(date), number);
}
export function subMinutes(date, number) {
  return dateFns.subMinutes(toDate(date), number);
}

export function subSeconds(date, number) {
  return dateFns.subSeconds(toDate(date), number);
}

export function getWeek(date) {
  return dateFns.getWeek(toDate(date), { locale: de, weekStartsOn: 1 });
}

export function getISOWeek(date) {
  return dateFns.getISOWeek(toDate(date));
}

export function getISOWeeksInYear(year) {
  return dateFns.getISOWeeksInYear(year);
}

export function getMonth(date) {
  return dateFns.getMonth(toDate(date));
}

export function getYear(date) {
  return dateFns.getYear(toDate(date));
}

export function setWeek(date, week) {
  return dateFns.setWeek(toDate(date), week, { locale: de, weekStartsOn: 1 });
}

export function setISOWeek(date, week) {
  return dateFns.setISOWeek(toDate(date), week);
}

export function months() {
  const months = [];
  for (let i = 0; i < 12; i++) {
    months.push(de.localize.month(i));
  }
  return months;
}

export function weekdays() {
  const now = new Date();
  const weekDays = [];
  const start = dateFns.startOfWeek(now, { locale: de });
  const end = dateFns.endOfWeek(now, { locale: de });
  dateFns.eachDayOfInterval({ start, end }).forEach((day) => {
    weekDays.push(dateFns.format(day, 'EEEE', { locale: de }));
  });
  return weekDays;
}

export function weekdaysUS() {
  const now = new Date();
  const weekDays = [];
  const start = dateFns.startOfWeek(now);
  const end = dateFns.endOfWeek(now);
  dateFns.eachDayOfInterval({ start, end }).forEach((day) => {
    weekDays.push(dateFns.format(day, 'EEEE', { locale: de }));
  });
  return weekDays;
}

export function eachMinuteOfInterval(startDate, endDate) {
  const interval = { start: toDate(startDate), end: toDate(endDate) };
  return dateFns.eachMinuteOfInterval(interval);
}

export function eachHourOfInterval(startDate, endDate) {
  const interval = { start: toDate(startDate), end: toDate(endDate) };
  return dateFns.eachHourOfInterval(interval);
}

export function eachDayOfInterval(startDate, endDate) {
  const interval = { start: toDate(startDate), end: toDate(endDate) };
  return dateFns.eachDayOfInterval(interval);
}

export function eachMonthOfInterval(startDate, endDate) {
  const interval = { start: toDate(startDate), end: toDate(endDate) };
  return dateFns.eachMonthOfInterval(interval);
}

/**
 * give each Year of given Interval (Start, End)
 * @param startDate
 * @param endDate
 * @returns {Date[]}
 */
export function eachYearOfInterval(startDate, endDate) {
  const interval = { start: toDate(startDate), end: toDate(endDate) };
  return dateFns.eachYearOfInterval(interval);
}

export function isWithinInterval(startDate, endDate, checkDate) {
  const interval = { start: toDate(startDate), end: toDate(endDate) };
  return dateFns.isWithinInterval(interval, toDate(checkDate));
}

export function differenceInMinutes(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return dateFns.differenceInMinutes(parsedDate, parsedDateToCompare);
}

export function differenceInHours(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return dateFns.differenceInHours(parsedDate, parsedDateToCompare);
}

export function differenceInDays(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return dateFns.differenceInDays(parsedDate, parsedDateToCompare);
}

export function isSameOrAfter(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return (
    dateFns.isEqual(parsedDate, parsedDateToCompare) ||
    dateFns.isAfter(parsedDate, parsedDateToCompare)
  );
}

export function isSameOrBefore(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return (
    dateFns.isEqual(parsedDate, parsedDateToCompare) ||
    dateFns.isBefore(parsedDate, parsedDateToCompare)
  );
}

export function isBefore(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return dateFns.isBefore(parsedDate, parsedDateToCompare);
}

export function isAfter(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return dateFns.isAfter(parsedDate, parsedDateToCompare);
}

export function isEqual(date, dateToCompare) {
  const parsedDate = toDate(date);
  const parsedDateToCompare = toDate(dateToCompare);
  return dateFns.isEqual(parsedDate, parsedDateToCompare);
}

export function isDateHoliday(date, bundesland = 'NRW') {
  return isHoliday(toDate(date), bundesland);
}

export function getDateHoliday(date, bundesland = 'NW') {
  return getHolidayByDate(toDate(date), bundesland)?.translate('de');
}

export function getHolidaysByYear(year, region = 'NW') {
  return getHolidays(year, region);
}

export function toDate(date) {
  if (!isValidDate(date)) {
    let parts = date.split('.');
    let newDate = new Date(parts[2], parts[1] - 1, parts[0]);
    if (!isValidDate(newDate)) {
      let parts = date.split('-');
      newDate = new Date(parts[0], parts[1] - 1, parts[2]);
      if (!isValidDate(newDate)) {
        return new Date(dateFns.parseISO(date));
      }
    }
    return newDate;
  }
  return date;
}

export function parse(value, format) {
  if (value === null || typeof value === 'undefined') {
    return null;
  }
  const type = typeof value;
  if (type === 'number' || value instanceof Date) {
    value = dateFns.toDate(value);
  } else if (type === 'string') {
    if (typeof format === 'string') {
      value = dateFns.parse(value, format, new Date(), this.options);
    } else {
      value = dateFns.parseISO(value, this.options);
    }
  }
  return dateFns.isValid(value) ? value : null;
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}
